import OmegaTracker from '@didi/omega-tracker/lib/index.js';
import config from '@/config/index';

import { requestCommonParams } from '@/lib/request/requestCommonParams';
import { is_mobile } from '@/utils/os'
import { getRecId } from "@/config/trackLog/func";
import { getLocalStorage } from '@/utils/localStorage';
import { getSessionStorage } from '@/utils/sessionStorage';
import { sleep } from '@/utils/tools';
import strategyLog, { TYPE_MAP } from '@/config/trackLog/StrategyLog';
import { EVENT_TAG_MAP } from '@/config/trackLog/strategyConf';

export const omega = OmegaTracker.getTracker(config.omega);
class OmegaUtil {
  constructor() {
    this.delayQueue = [];
    this.delayTag = false;
  }
  log({ eventId, eventLabel, attrs }) {
    const commonAttrs = this._getCommonParams(eventId);
    const isLogin = this._isLogin();
    const uid = this._getUID();

    if (isLogin && !uid) {
      this.delayTag = true;
      this.delayQueue.push({ eventId, eventLabel, attrs: { ...commonAttrs, ...attrs } })
      return;
    }

    if (this.delayTag && this.delayQueue.length > 0) {
      this.delayTag = false;
      this._sendLogStrategy();
    }

    this._trackEvent(eventId, eventLabel, { ...commonAttrs, ...attrs });
  }
  async _trackEvent(eventId, eventLabel, attrs) {
    if (config.env.isPro) {
      omega.trackEvent(eventId, eventLabel, attrs);
      return;
    }
    console.log('测试环境拦截Omega埋点上报', { eventId, eventLabel, ...attrs })
  }
  async _sendLogStrategy() {
    const uid = this._getUID();
    const logs = this.delayQueue.splice(0, 5);

    logs.forEach(log => {
      let { eventId, eventLabel, attrs } = log;
      attrs.uid = uid;
      this._trackEvent(eventId, eventLabel, attrs)
    })

    if (this.delayQueue.length > 0) {
      await sleep(200);
      this._sendLogStrategy();
    }
  }
  _getCommonParams(eventId) {
    const { poiId, cityId, lat, lng, poiCountyId, poiCountyGroupId, osType } = requestCommonParams();
    const uid = this._isLogin() ? this._getUID() : -1;
    const op_system = is_mobile() ? 'phone_web' : 'pc_web';
    const recId = this._getRecId(eventId);
    const lv1Tag = this._isAddLV1Info(eventId); // LV1_标识
    const pub_channel_type = getSessionStorage('pub_channel_type')
    const commonAttrs = {
      poi_id: poiId,
      poi_city_id: cityId,
      poi_latitude: lat,
      poi_longitude: lng,
      pub_poi_county_id: poiCountyId,
      pub_poi_county_group_id: poiCountyGroupId,
      os_type: osType,
      uid,
      op_system,
      pub_channel_type
    }

    if (recId) {
      commonAttrs.rec_id = recId;
    }

    if (lv1Tag) {
      const { lv1_location, lv1_recid } = this._getLV1Info()
      commonAttrs.lv1_location = lv1_location;
      commonAttrs.lv1_recid = lv1_recid;
    }

    return commonAttrs;
  }
  _isLogin() {
    return getLocalStorage('isLogin');
  }
  _getUID() {
    return getLocalStorage('uid') || '';
  }
  _getRecId(eventId) {
    return getRecId(eventId) || '';
  }
  _isAddLV1Info(eventId) {
    return +strategyLog.getEventStrategyTag(eventId) === +EVENT_TAG_MAP.LV1_TAG
  }
  _getLV1Info() {
    const { lv1_location, lv1_recid } = strategyLog.getStrategyData(TYPE_MAP.LV1_INFO);
    return { lv1_location, lv1_recid }
  }
}

const util = new OmegaUtil();

export function trackEvent(logData) {
  return util.log(logData);
}
